import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const bvsApi = {
  getAll(params?: cyrian.api.bvs.GetParams): ApiResponse<WrappedResult<cyrian.api.bvs.BV[]>> {
    return request({
      method: 'get',
      url: '/bvs',
      params,
    });
  },
  get(id: number): ApiResponse<WrappedResult<cyrian.api.bvs.BVWithAttachment>> {
    return request({
      method: 'get',
      url: `/bvs/${id}`,
    });
  },
  create(data: cyrian.api.bvs.BVParams): ApiResponse<WrappedResult<cyrian.api.bvs.BV>> {
    return request({
      method: 'post',
      url: '/bvs',
      data,
    });
  },
  update(bvId: number, data: cyrian.api.bvs.BVParams): ApiResponse<WrappedResult<cyrian.api.bvs.BV>> {
    return request({
      method: 'patch',
      url: `/bvs/${bvId}`,
      data,
    });
  },
  delete(bvId: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/bvs/${bvId}`,
    });
  },
};

export default bvsApi;
